import { message } from 'antd';
import * as intl from 'react-intl-universal';
import Http from 'common/utils/http';
import errors, { whiteList } from 'common/utils/http/errors';
import { list } from './retry';

const http = Http({
    onError: ({ code, data }: any, url: string) => {
        if (!whiteList.includes(url)) {
            if (code === 2000 || code === 2800 || code === 2801 || code === 2802 || code === 2803) {
                setTimeout(() => window.location.reload(), 3000);
            }
            if (code === 230002) {
                // 无时段查询权限:用 warning 而非 error,固定 key 去重(与页面短路提示同 key)
                message.warning({ content: intl.get(errors[code]).d(errors[code]), key: 'no-time-range-permission' });
            } else if (code == 6300) {
                data.message && message.error(intl.get('Error.ExportExceedsLimit', { field: data.message.info }));
            } else {
                code !== 2009 &&
                    message.error(
                        errors[code]
                            ? intl.get(errors[code]).d(errors[code])
                            : data || intl.get('Error.ClientUnknownError'),
                    );
            }
        }
    },
    retry: {
        list,
        callback: (delay: number) => {
            message.error(intl.get('Hint.RetryRequest', { delay }).d(`请求失败，${delay} 秒后自动重试`));
        },
    },
});

const get = http('get');
const post = http('post');
const upload = http('upload');

export { get, post, upload };
